import { Loader2 } from 'lucide-react';

interface PageSuspenseFallbackProps {
  title?: string;
}

export function PageSuspenseFallback({ title }: PageSuspenseFallbackProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] gap-3">
      <Loader2 className="w-6 h-6 animate-spin text-muted-foreground" />
      {title && (
        <p className="text-sm text-muted-foreground">{title}</p>
      )}
    </div>
  );
}
